import React from 'react';

const KebabMenuIcon = (props: any) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.7854 15.9996C15.7854 16.4967 16.1884 16.8996 16.6854 16.8996C17.1825 16.8996 17.5854 16.4967 17.5854 15.9996C17.5854 15.5026 17.1825 15.0996 16.6854 15.0996C16.1884 15.0996 15.7854 15.5026 15.7854 15.9996Z"
      stroke={props.color || '#1F221F'}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7854 22.2999C15.7854 22.797 16.1884 23.1999 16.6854 23.1999C17.1825 23.1999 17.5854 22.797 17.5854 22.2999C17.5854 21.8028 17.1825 21.3999 16.6854 21.3999C16.1884 21.3999 15.7854 21.8028 15.7854 22.2999Z"
      stroke={props.color || '#1F221F'}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7854 9.6998C15.7854 10.1969 16.1884 10.5998 16.6854 10.5998C17.1825 10.5998 17.5854 10.1969 17.5854 9.6998C17.5854 9.20275 17.1825 8.7998 16.6854 8.7998C16.1884 8.7998 15.7854 9.20275 15.7854 9.6998Z"
      stroke={props.color || '#1F221F'}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KebabMenuIcon;
